import { entries, isArray, isObject } from 'lodash'

export interface CollectionOption {
    value: any
    label?: string
    [key: string]: any
}

export type CollectionOptionsArgument = CollectionOption[]|any[]|{ [key: string]: string };

export function resolveOptions(options: CollectionOptionsArgument): CollectionOption[] {

    let resolvedOptions = [];

    if(isArray(options)){

        let counter = 1;

        for(let option of options){

            if(isObject(option)){
                resolvedOptions.push(option);
            }
            else {
                resolvedOptions.push({ label: option.toString(), value: option });
            }

            counter++;
        }
    }
    else if(isObject(options)){

        for(let [key, value] of entries(options)){

            resolvedOptions.push({ label: value, value: key });
        }
    }

    return resolvedOptions;
}